import {Directive, ElementRef, Input, TemplateRef, ViewContainerRef} from '@angular/core'
import {UserSessionService} from '../../../services/user-session.service'
import {PERMISSION} from "@generated-backend-types";

@Directive({
    selector: '[appIfHasAnyPermissions]',
    standalone: true
})
export class IfHasAnyPermissionDirective {
  @Input() set appIfHasAnyPermissions(permissions: PERMISSION[]) {
    if (permissions && permissions.length > 0 && this.authService.hasAnyPermission(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }

  public constructor(
    private readonly element: ElementRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly authService: UserSessionService
  ) {
  }
}
